import React, { useEffect, useRef, useState } from "react";
import { IoPersonCircleOutline } from "react-icons/io5";
import { PiShootingStar } from "react-icons/pi";
import { Dialog } from "primereact/dialog";
import "./Chat.scss";
import CodeEditor from "../CodeEditor/CodeEditor";
import MarkedRender from "../MarkedRender/MarkedRender";
import PropTypes from "prop-types";
import { IoThumbsUpSharp, IoThumbsDownSharp } from 'react-icons/io5';

// PropTypes validation
ChatResult.propTypes = {
  activeChatBot: PropTypes.array.isRequired,
};

export default function ChatResult({ activeChatBot }) {
  const messageEndRef = useRef();
  const [chatVisible, setChatVisible] = useState(false);
  const [highlightLine, setHighlightLine] = useState(0);
  const [fileName, setFileName] = useState("Sample.json");

  useEffect(() => {
    messageEndRef.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  }, [activeChatBot]);

  const openPopup = (id, filename) => {
    setChatVisible(true);
    setHighlightLine(id);
    setFileName(filename);
  };
  const setFeedback = async (chatId, feedback) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/chat_routers/setFeedback/${chatId}/${feedback}`, {
        method: "PUT"
      })
      console.log("Setting feedback");

      console.log(await response.json());

    }
    catch (err) {
      console.log("Error in setting feedback");

    }
  }
  return (
    <div className="chats">
      
      {activeChatBot &&
        activeChatBot.map((item, i) => {
          return (
            <div className={`item ${item.sender}`} key={i}>
              <div className="chat">
                {item.sender === "ai" ? (
                  <>
                 
                    <span className="icon">
                      <PiShootingStar />
                    </span>
                    <div className="marked">
                      <MarkedRender
                        message={item.message}
                        openPopup={openPopup}
                      />
                      <div className="feedback">
                        {/* {item.chatId ?
                          <>
                            <IoThumbsUpSharp style={{ cursor: "pointer" }} onClick={() => { setFeedback(item.chatId, true) }} />
                            <IoThumbsDownSharp style={{ cursor: "pointer" }} onClick={() => { setFeedback(item.chatId, false) }} />
                          </> :
                          <> */}
                            <IoThumbsUpSharp className="thumbUp" style={{ cursor: "pointer"}}  onClick={()=>{setFeedback(item.chatId,true)
                            }}/>
                            <IoThumbsDownSharp style={{ cursor: "pointer" }} onClick={()=>{setFeedback(item.chatId,false)}}/>
                          {/* </>} */}
                      </div>

                    </div>
                  </>
                ) : (
                  <>
                    <span className="icon">
                      <IoPersonCircleOutline />
                    </span>
                    <p>{item.message}</p>
                  </>
                )}
              </div>
            </div>
          );
        })}
      <div ref={messageEndRef} />
      <Dialog
        header={fileName}
        visible={chatVisible}
        closeOnEscape={true}
        dismissableMask={true}
        position="right"
        style={{ width: "35vw" }}
        onHide={() => {
          setChatVisible(false);
        }}
        draggable={false}
        resizable={false}
      >
        <CodeEditor highlightLine={highlightLine} />
      </Dialog>

    </div>
  );
}

